import { withTranslation } from "react-i18next";
import {
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Popover,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Tooltip,
} from "@material-ui/core";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import network from "../../../actions/external/network";
import { downloadBlob } from "../../../scripts/utils";
import { toastr } from "react-redux-toastr";
import DatePicker from "../../common/DatePicker";
import codes from "../../common/codes";

class MultiEdition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainCheck: true,
      orderBy: "asc",
      searchContent: "",
      anchorEl: null,
      structureCollective: [],
      structureCollectiveFilter: null,
      startDateAuditFilter: null,
      endDateAuditFilter: null,
      etatDossierFilter: "TOUS",
      resultatAuditFilter: "TOUS",
      exploitationsToExportVisible: [],
      exploitationsToExportSelected: [],
    };
  }

  componentDidMount() {
    this.loadData();
    const exploitationsToExportVisible = this.props.exploitations
      .filter((exploitation) =>
        exploitation.demarches.some(
          (demarche) =>
            demarche.idMillesime === this.props.millesime &&
            demarche.libelle === "Certification Environnementale HVE Référentiel V4"
        )
      )
      .toSorted(
        (exploitA, exploitB) =>
          exploitA.raisonSociale.localeCompare(exploitB.raisonSociale) * (this.state.orderBy === "asc" ? 1 : -1)
      )
      .filter((exploit) => exploit.raisonSociale.toLowerCase().includes(this.state.searchContent.toLowerCase()));

    this.setState({
      exploitationsToExportSelected: this.props.exploitations.filter((exploitation) =>
        exploitation.demarches.some((demarche) => demarche.idMillesime === this.props.millesime)
      ),
      mainCheck: true,
      orderBy: "asc",
      searchContent: "",
      anchorEl: null,
      exploitationsToExportVisible,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const exploitationsToExportVisible = this.props.exploitations
      .filter((exploitation) =>
        exploitation.demarches.some(
          (demarche) =>
            demarche.idMillesime === this.props.millesime &&
            demarche.libelle === "Certification Environnementale HVE Référentiel V4"
        )
      )
      .toSorted(
        (exploitA, exploitB) =>
          exploitA.raisonSociale.localeCompare(exploitB.raisonSociale) * (this.state.orderBy === "asc" ? 1 : -1)
      )
      .filter((exploit) => exploit.raisonSociale.toLowerCase().includes(this.state.searchContent.toLowerCase()))
      .filter((exploit) => {
        const demarche = exploit.demarches.find(
          (d) =>
            d.idMillesime === this.props.millesime && d.libelle === "Certification Environnementale HVE Référentiel V4"
        );

        if (!demarche) return false;

        if (this.state.startDateAuditFilter && demarche.dateAudit) {
          if (demarche.dateAudit < this.state.startDateAuditFilter) return false;
        }

        if (this.state.endDateAuditFilter && demarche.dateAudit) {
          if (demarche.dateAudit > this.state.endDateAuditFilter) return false;
        }

        if (this.state.etatDossierFilter !== "TOUS" && demarche.etatDossier !== this.state.etatDossierFilter) {
          return false;
        }

        if (this.state.resultatAuditFilter !== "TOUS" && demarche.resultatAudit !== this.state.resultatAuditFilter) {
          return false;
        }

        if (this.state.structureCollectiveFilter !== null) {
          return parseInt(demarche.nomStructureCollective) === this.state.structureCollectiveFilter;
        }

        return true;
      });

    // 💡 NE mettre à jour que si le contenu est réellement différent
    if (JSON.stringify(exploitationsToExportVisible) !== JSON.stringify(this.state.exploitationsToExportVisible)) {
      this.setState({
        exploitationsToExportVisible,
      });
    }
    if (exploitationsToExportVisible.length === 0 && prevState.exploitationsToExportVisible.length !== 0) {
      this.handleMainCheck(false);
    }
  }

  loadData = async () => {
    const { t } = this.props;
    try {
      const [structureCollective] = await Promise.all([network.fetch(`/api/structure-collective`)]);

      this.setState({
        structureCollective: structureCollective,
      });
    } catch (error) {
      toastr.error(t("error", "Erreur"), error.message);
    }
  };

  handleExploitationToExport = (event, checked, exploitation) => {
    const { exploitationsToExportSelected } = this.state;
    if (checked) {
      exploitationsToExportSelected.push(exploitation);
      this.setState({ exploitationsToExportSelected: exploitationsToExportSelected });
    } else {
      this.setState({
        exploitationsToExportSelected: exploitationsToExportSelected.filter(
          (exploitationToRemove) => exploitationToRemove.idExploitation !== exploitation.idExploitation
        ),
      });
    }
  };

  sortHandler = () => {
    this.setState({
      orderBy: this.state.orderBy === "asc" ? "desc" : "asc",
    });
  };

  handleMainCheck(checked) {
    if (checked) {
      this.setState({
        exploitationsToExportSelected: [
          ...this.state.exploitationsToExportSelected,
          ...this.state.exploitationsToExportVisible,
        ],
        mainCheck: true,
      });
    } else {
      this.setState((prevState) => ({
        exploitationsToExportSelected: prevState.exploitationsToExportSelected.filter(
          (item) =>
            !prevState.exploitationsToExportVisible.some(
              (visibleItem) => visibleItem.idExploitation === item.idExploitation
            )
        ),
        mainCheck: false,
      }));
    }
  }

  printEdition = async (name, format) => {
    const { exploitationsToExportSelected, exploitationsToExportVisible } = this.state;

    const idsToExport = exploitationsToExportSelected
      .map((exploit) => exploit.idExploitation)
      .filter((id) => exploitationsToExportVisible.some((f) => f.idExploitation === id));

    const params = {
      id_millesime: this.props.millesime,
      ids_exploitations: idsToExport,
      format,
    };

    try {
      const response = await network.fetch(`/api/editions/${name}/multiexploitation`, {
        method: "POST",
        body: JSON.stringify(params),
      });
      await downloadBlob(response);
    } catch (error) {
      toastr.error("Erreur", error.message);
    }
    this.props.onClose();
  };

  handleOpenPopper = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClosePopper = () => {
    this.setState({ anchorEl: null });
  };

  handleSearch = (event) => {
    this.setState({ searchContent: event.target.value });
  };

  render() {
    const { exploitations, onClose } = this.props;
    const { anchorEl, exploitationsToExportVisible } = this.state;

    const hasExploitations =
      exploitations.filter((exploitation) =>
        exploitation.demarches.some((demarche) => demarche.idMillesime === this.props.millesime)
      ).length > 0;

    return (
      <React.Fragment>
        <div>Vous vous apprêtez à lancer une édition pour la démarche MesCertifications HVE4.</div>
        <div>
          Cette éditions porte par défaut sur l'ensemble de votre portefeuille d'exploitations. Si vous souhaitez
          exclure certaines exploitations, supprimez-les de la liste ci-dessous :
        </div>
        <div className={"mt-2 d-flex flex-row align-items-center"}>
          <div>
            <DatePicker
              format="DD/MM/yyyy"
              label={"Date d'audit début"}
              value={this.state.startDateAuditFilter}
              onChange={(value) =>
                this.setState({
                  startDateAuditFilter: value?.format("YYYY-MM-DD"),
                })
              }
            />
          </div>
          <div className={"ml-2"}>
            <DatePicker
              disableToolbar
              format="DD/MM/yyyy"
              label={"Date d'audit fin"}
              value={this.state.endDateAuditFilter}
              onChange={(value) =>
                this.setState({
                  endDateAuditFilter: value?.format("YYYY-MM-DD"),
                })
              }
            />
          </div>

          <div className={"ml-2"}>
            <FormControl variant="outlined" className="ml-1">
              <InputLabel id="etat-dossier-label">État du dossier</InputLabel>
              <Select
                labelId="etat-dossier-label"
                label="État du dossier"
                displayEmpty
                value={this.state.etatDossierFilter || "TOUS"}
                onChange={(e) => this.setState({ etatDossierFilter: e.target.value })}
              >
                <MenuItem value="TOUS">
                  <em>--Tous--</em>
                </MenuItem>
                {codes.procedureStates
                  .filter((item) => item.code !== "CERTIFIABLE" && item.code !== "NON_CERTIFIABLE")
                  .map(({ libelle, code }, i) => (
                    <MenuItem key={i} value={code}>
                      {libelle}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </div>

          <div className={"ml-2"} style={{ minWidth: "15em" }}>
            <FormControl variant="outlined" className="ml-1">
              <InputLabel id="resultat-audit-label">Résultat de l'audit</InputLabel>
              <Select
                labelId="resultat-audit-label"
                label="Résultat de l'audit"
                displayEmpty
                value={this.state.resultatAuditFilter || ""}
                onChange={(e) => {
                  this.setState({ resultatAuditFilter: e.target.value });
                }}
              >
                <MenuItem value="TOUS">
                  <em>--Tous--</em>
                </MenuItem>
                {codes.procedureStates
                  .filter((item) => item.code === "CERTIFIABLE" || item.code === "NON_CERTIFIABLE")
                  .map(({ libelle, code }, i) => (
                    <MenuItem key={i} value={code}>
                      {libelle}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <TableContainer
          component={Paper}
          style={{
            maxHeight: "60vh",
            minHeight: "60vh",
          }}
          className={"mt-2"}
        >
          <Table stickyHeader={true}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Checkbox
                    color={"primary"}
                    indeterminate={
                      this.state.exploitationsToExportSelected.length !==
                        this.state.exploitationsToExportVisible.length &&
                      this.state.exploitationsToExportSelected.length > 0
                    }
                    checked={exploitationsToExportVisible
                      .map((e) => e.idExploitation)
                      .every((id) =>
                        this.state.exploitationsToExportSelected.map((e) => e.idExploitation).includes(id)
                      )}
                    onChange={(event, checked) => this.handleMainCheck(checked)}
                  />
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    className={"bold"}
                    active={true}
                    direction={this.state.orderBy}
                    onClick={() => this.sortHandler()}
                  >
                    Raison sociale
                  </TableSortLabel>
                  <Tooltip title={"Rechercher une exploitation"} placement={"top"}>
                    <IconButton onClick={this.handleOpenPopper}>
                      <FontAwesomeIcon icon={"search"} />
                    </IconButton>
                  </Tooltip>
                  <Popover anchorEl={anchorEl} open={!!anchorEl} placement={"top"}>
                    <ClickAwayListener onClickAway={this.handleClosePopper}>
                      <Paper>
                        <TextField
                          onChange={(event) => this.handleSearch(event)}
                          placeholder={"Rechercher une exploitation"}
                          value={this.state.searchContent}
                          style={{
                            width: "20rem",
                          }}
                        />
                      </Paper>
                    </ClickAwayListener>
                  </Popover>
                </TableCell>
                <TableCell>
                  <div className={"bold"}>SIRET</div>
                </TableCell>
                <TableCell>
                  <div className={"bold"}>Commune</div>
                </TableCell>
                <TableCell>
                  <div className={"d-flex align-items-center"}>
                    <div className={"bold"}>Structure collective</div>
                    <FormControl variant="outlined" size="small" className={"ml-1"}>
                      <Select
                        displayEmpty
                        value={this.state.structureCollectiveFilter || ""}
                        onChange={(e) =>
                          this.setState({ structureCollectiveFilter: e.target.value === "" ? null : e.target.value })
                        }
                      >
                        <MenuItem value="">--Toutes--</MenuItem>
                        {this.state.structureCollective
                          .filter((structure) => {
                            const idsStructuresCollectives = exploitationsToExportVisible.map(
                              (exploitation) =>
                                exploitation.demarches.filter(
                                  (demarche) =>
                                    demarche.idMillesime === this.props.millesime &&
                                    demarche.libelle === "Certification Environnementale HVE Référentiel V4"
                                )[0]?.nomStructureCollective
                            );

                            return idsStructuresCollectives.some(
                              (id) => parseInt(id) === structure.idStructureCollective
                            );
                          })
                          .map((structure) => (
                            <MenuItem key={structure.idStructureCollective} value={structure.idStructureCollective}>
                              {structure.libelle}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!hasExploitations ? (
                <TableRow className={"d-flex justify-center"}>
                  <TableCell align={"center"} colSpan={5}>
                    Aucune exploitation ayant une démarche réalisée en {this.props.millesime} n'est disponible
                  </TableCell>
                </TableRow>
              ) : (
                exploitationsToExportVisible.map((exploitation) => (
                  <TableRow key={`exploitation-${exploitation.idExploitation}`}>
                    <TableCell>
                      <Checkbox
                        color={"primary"}
                        checked={this.state.exploitationsToExportSelected.includes(exploitation)}
                        onChange={(event, checked) => this.handleExploitationToExport(event, checked, exploitation)}
                      />
                    </TableCell>
                    <TableCell>{exploitation.raisonSociale}</TableCell>
                    <TableCell>{exploitation.siret}</TableCell>
                    <TableCell>{exploitation.nomCommune}</TableCell>
                    <TableCell>
                      {
                        this.state.structureCollective.find(
                          (s) =>
                            s.idStructureCollective ===
                            parseInt(
                              exploitation.demarches.filter(
                                (demarche) =>
                                  demarche.idMillesime === this.props.millesime &&
                                  demarche.libelle === "Certification Environnementale HVE Référentiel V4"
                              )[0].nomStructureCollective
                            )
                        )?.libelle
                      }
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Box className={"d-flex justify-center mt-2"}>
          <Button className={"mr-1"} variant={"contained"} onClick={onClose}>
            <FontAwesomeIcon icon={"times"} style={{ height: "20px", width: "20px" }} className={"mr-05"} />
            Annuler
          </Button>
          <Button
            color={"primary"}
            variant={"contained"}
            onClick={() => this.printEdition("HVE4", "xlsx")}
            disabled={
              this.state.exploitationsToExportSelected.length === 0 ||
              this.state.exploitationsToExportVisible.length === 0 ||
              !this.state.exploitationsToExportVisible
                .map((e) => e.idExploitation)
                .some((id) => this.state.exploitationsToExportSelected.map((e) => e.idExploitation).includes(id))
            }
          >
            <FontAwesomeIcon icon={"print"} style={{ height: "20px", width: "20px" }} className={"mr-05"} />
            Lancer l'édition
          </Button>
        </Box>
      </React.Fragment>
    );
  }
}

export default withTranslation()(MultiEdition);
